"use client";

import { useNavigation } from "@/hooks/useNavigation";
import { useCallback } from "react";
import ym, { YMInitializer } from "react-yandex-metrika";

//Check, is it production mode
export const enableYM =
  process.env.NODE_ENV === "production" && process.env.NEXT_PUBLIC_YM_ID;

export const YandexMetrica = () => {
  const hit = useCallback((url: string) => {
    if (enableYM) {
      ym("hit", url);
    } else {
      console.log(`%c[YandexMetrika](HIT)`, `color: orange`, url);
    }
  }, []);

  useNavigation({
    on: {
      routeChanged: ({ url }) => {
        // @ts-ignore
        hit(url);
      },
    },
  });
  return (
    <>
      {enableYM && (
        <YMInitializer
          accounts={[Number(process.env.NEXT_PUBLIC_YM_ID)]}
          options={{
            clickmap: true,
            trackLinks: true,
            accurateTrackBounce: true,
            webvisor: true,
          }}
        />
      )}
    </>
  );
};
